<template>
<div class="page-container">
  <el-breadcrumb separator="/">
    <el-breadcrumb-item>
      <span class="page-title">投票设置</span>
    </el-breadcrumb-item>
    <el-breadcrumb-item>币种设置</el-breadcrumb-item>
  </el-breadcrumb>
  <el-card class="page-content" shadow="never">
    <div class="page-actions">
      <create-coin @refresh="refreshList"></create-coin>
    </div>
    <coin-list @refresh="refreshList"></coin-list>
  </el-card>
</div>
</template>

<script>
import './store';
import CreateCoin from './components/create';
import CoinList from './components/list';
import { mapActions, mapState } from 'vuex';
import { PAGINATION } from 'common/config';

export default {
  name: 'VoteCoin',
  components: {
    CreateCoin,
    CoinList
  },
  data() {
    return {
      query: ''
    };
  },
  computed: {
    ...mapState('voteCoinSetting', ['pagination'])
  },
  methods: {
    ...mapActions('voteCoinSetting', ['list']),
    refreshList(data) {
      this.list({
        coinType: this.query,
        ...this.pagination,
        ...data
      });
    }
  },
  created() {
    this.list({
      ...PAGINATION
    });
  }
};
</script>

<style>
</style>
